import { render, staticRenderFns } from "./HelpMenu.vue?vue&type=template&id=4128b94a&scoped=true"
import script from "./HelpMenu.vue?vue&type=script&lang=js"
export * from "./HelpMenu.vue?vue&type=script&lang=js"
import style0 from "./HelpMenu.vue?vue&type=style&index=0&id=4128b94a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4128b94a",
  null
  
)

export default component.exports